var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _ = require('lodash');

var prefixNegativeModifiers = function prefixNegativeModifiers(base, modifier) {
  return _.startsWith(modifier, '-') ? "-".concat(base, "-").concat(modifier.slice(1)) : "".concat(base, "-").concat(modifier);
};

module.exports = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (_ref) {
    var theme = _ref.theme,
        variants = _ref.variants,
        e = _ref.e,
        addUtilities = _ref.addUtilities;
    var defaultOptions = {
      '3d': false
    };
    options = _.defaults({}, options, defaultOptions);
    var defaultTransformTheme = {
      'none': 'none'
    };
    var defaultTransformVariants = ['responsive'];
    var defaultTransformOriginTheme = {
      't': 'top',
      'tr': 'top right',
      'r': 'right',
      'br': 'bottom right',
      'b': 'bottom',
      'bl': 'bottom left',
      'l': 'left',
      'tl': 'top left'
    };
    var defaultTransformOriginVariants = ['responsive'];
    var defaultTranslateTheme = {};
    var defaultTranslateVariants = ['responsive'];
    var defaultScaleTheme = {};
    var defaultScaleVariants = ['responsive'];
    var defaultRotateTheme = {};
    var defaultRotateVariants = ['responsive'];
    var defaultSkewTheme = {};
    var defaultSkewVariants = ['responsive'];
    var defaultPerspectiveTheme = {};
    var defaultPerspectiveVariants = ['responsive'];
    var defaultPerspectiveOriginTheme = {
      't': 'top',
      'tr': 'top right',
      'r': 'right',
      'br': 'bottom right',
      'b': 'bottom',
      'bl': 'bottom left',
      'l': 'left',
      'tl': 'top left'
    };
    var defaultPerspectiveOriginVariants = ['responsive'];
    var defaultTransformStyleVariants = ['responsive'];
    var defaultBackfaceVisibilityVariants = ['responsive'];
    var defaultTransformBoxVariants = ['responsive'];
    var transformTheme = theme('transform', defaultTransformTheme);
    var transformVariants = variants('transform', defaultTransformVariants);
    var transformOriginTheme = theme('transformOrigin', defaultTransformOriginTheme);
    var transformOriginVariants = variants('transformOrigin', defaultTransformOriginVariants);
    var translateTheme = theme('translate', defaultTranslateTheme);
    var translateVariants = variants('translate', defaultTranslateVariants);
    var scaleTheme = theme('scale', defaultScaleTheme);
    var scaleVariants = variants('scale', defaultScaleVariants);
    var rotateTheme = theme('rotate', defaultRotateTheme);
    var rotateVariants = variants('rotate', defaultRotateVariants);
    var skewTheme = theme('skew', defaultSkewTheme);
    var skewVariants = variants('skew', defaultSkewVariants);
    var perspectiveTheme = theme('perspective', defaultPerspectiveTheme);
    var perspectiveVariants = variants('perspective', defaultPerspectiveVariants);
    var perspectiveOriginTheme = theme('perspectiveOrigin', defaultPerspectiveOriginTheme);
    var perspectiveOriginVariants = variants('perspectiveOrigin', defaultPerspectiveOriginVariants);
    var transformStyleVariants = variants('transformStyle', defaultTransformStyleVariants);
    var backfaceVisibilityVariants = variants('backfaceVisibility', defaultBackfaceVisibilityVariants);
    var transformBoxVariants = variants('transformBox', defaultTransformBoxVariants);

    var transformUtilities = _.fromPairs(_.map(transformTheme, function (value, modifier) {
      return [".".concat(e("transform-".concat(modifier))), {
        transform: value
      }];
    }));

    var transformOriginUtilities = _.fromPairs(_.map(transformOriginTheme, function (value, modifier) {
      return [".".concat(e("transform-".concat(modifier))), {
        transformOrigin: value
      }];
    }));

    var translateUtilities = _.fromPairs(_.concat.apply(_, _toConsumableArray(_.map(translateTheme, function (value, modifier) {
      if (_.isArray(value)) {
        if (value.length === 0) {
          return [];
        }

        if (value.length >= 3) {
          return [[".".concat(e(prefixNegativeModifiers('translate', modifier))), {
            transform: "translate3d(".concat(value[0], ", ").concat(value[1], ", ").concat(value[2], ")")
          }]];
        }

        if (value.length >= 2) {
          return [[".".concat(e(prefixNegativeModifiers('translate', modifier))), {
            transform: "translate(".concat(value[0], ", ").concat(value[1], ")")
          }]];
        }

        value = value[0];
      }

      return [[".".concat(e(prefixNegativeModifiers('translate-x', modifier))), {
        transform: "translateX(".concat(value, ")")
      }], [".".concat(e(prefixNegativeModifiers('translate-y', modifier))), {
        transform: "translateY(".concat(value, ")")
      }]].concat(_toConsumableArray(!options['3d'] ? [] : [[".".concat(e(prefixNegativeModifiers('translate-z', modifier))), {
        transform: "translateZ(".concat(value, ")")
      }]]));
    }))));

    var scaleUtilities = _.fromPairs(_.concat.apply(_, _toConsumableArray(_.map(scaleTheme, function (value, modifier) {
      if (_.isArray(value)) {
        if (value.length === 0) {
          return [];
        }

        if (value.length >= 3) {
          return [[".".concat(e(prefixNegativeModifiers('scale', modifier))), {
            transform: "scale3d(".concat(value[0], ", ").concat(value[1], ", ").concat(value[2], ")")
          }]];
        }

        if (value.length >= 2) {
          return [[".".concat(e(prefixNegativeModifiers('scale', modifier))), {
            transform: "scale(".concat(value[0], ", ").concat(value[1], ")")
          }]];
        }

        value = value[0];
      }

      return [[".".concat(e(prefixNegativeModifiers('scale', modifier))), {
        transform: "scale(".concat(value, ")")
      }], [".".concat(e(prefixNegativeModifiers('scale-x', modifier))), {
        transform: "scaleX(".concat(value, ")")
      }], [".".concat(e(prefixNegativeModifiers('scale-y', modifier))), {
        transform: "scaleY(".concat(value, ")")
      }]].concat(_toConsumableArray(!options['3d'] ? [] : [[".".concat(e(prefixNegativeModifiers('scale-z', modifier))), {
        transform: "scaleZ(".concat(value, ")")
      }]]));
    }))));

    var rotateUtilities = _.fromPairs(_.concat.apply(_, _toConsumableArray(_.map(rotateTheme, function (value, modifier) {
      if (_.isArray(value)) {
        if (value.length === 0) {
          return [];
        }

        if (value.length >= 4) {
          return [[".".concat(e(prefixNegativeModifiers('rotate', modifier))), {
            transform: "rotate3d(".concat(value[0], ", ").concat(value[1], ", ").concat(value[2], ", ").concat(value[3], ")")
          }]];
        }

        value = value[0];
      }

      return [[".".concat(e(prefixNegativeModifiers('rotate', modifier))), {
        transform: "rotate(".concat(value, ")")
      }]].concat(_toConsumableArray(!options['3d'] ? [] : [[".".concat(e(prefixNegativeModifiers('rotate-x', modifier))), {
        transform: "rotateX(".concat(value, ")")
      }], [".".concat(e(prefixNegativeModifiers('rotate-y', modifier))), {
        transform: "rotateY(".concat(value, ")")
      }]]));
    }))));

    var skewUtilities = _.fromPairs(_.concat.apply(_, _toConsumableArray(_.map(skewTheme, function (value, modifier) {
      return [[".".concat(e(prefixNegativeModifiers('skew-x', modifier))), {
        transform: "skewX(".concat(value, ")")
      }], [".".concat(e(prefixNegativeModifiers('skew-y', modifier))), {
        transform: "skewY(".concat(value, ")")
      }]];
    }))));

    var perspectiveUtilities = _.fromPairs(_.map(perspectiveTheme, function (value, modifier) {
      return [".".concat(e("perspective-".concat(modifier))), {
        perspective: value
      }];
    }));

    var perspectiveOriginUtilities = _.fromPairs(_.map(perspectiveOriginTheme, function (value, modifier) {
      return [".".concat(e("perspective-".concat(modifier))), {
        perspectiveOrigin: value
      }];
    }));

    var transformStyleUtilities = {
      '.transform-flat': {
        transformStyle: 'flat'
      },
      '.transform-preserve-3d': {
        transformStyle: 'preserve-3d'
      }
    };
    var backfaceVisibilityUtilities = {
      '.backface-visible': {
        backfaceVisibility: 'visible'
      },
      '.backface-hidden': {
        backfaceVisibility: 'hidden'
      }
    };
    var transformBoxUtilities = {
      '.transform-border': {
        transformBox: 'border-box'
      },
      '.transform-fill': {
        transformBox: 'fill-box'
      },
      '.transform-view': {
        transformBox: 'view-box'
      }
    };
    addUtilities(transformUtilities, transformVariants);
    addUtilities(transformOriginUtilities, transformOriginVariants);
    addUtilities(translateUtilities, translateVariants);
    addUtilities(scaleUtilities, scaleVariants);
    addUtilities(rotateUtilities, rotateVariants);
    addUtilities(skewUtilities, skewVariants);

    if (options['3d']) {
      addUtilities(perspectiveUtilities, perspectiveVariants);
      addUtilities(perspectiveOriginUtilities, perspectiveOriginVariants);
      addUtilities(transformStyleUtilities, transformStyleVariants);
      addUtilities(backfaceVisibilityUtilities, backfaceVisibilityVariants);
    }

    addUtilities(transformBoxUtilities, transformBoxVariants);
  };
};